import * as React from 'react';

import { useGlobalInsightsPolling } from '~teacher/hook/activity/insights/useGlobalInsightsPolling';

/**
 * Component that manages global insights polling
 * Should be mounted at the app level
 */
export function GlobalInsightsPoller() {
  useGlobalInsightsPolling();
  return null;
}
